var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24 12.0735C24 5.40532 18.6277 0 12.0015 0C5.37233 0.00149981 0 5.40533 0 12.075C0 18.0997 4.38845 23.0941 10.1237 24V15.5636H7.07911V12.075H10.1267V9.41282C10.1267 6.3877 11.919 4.71691 14.6592 4.71691C15.973 4.71691 17.3453 4.95238 17.3453 4.95238V7.92201H15.832C14.3427 7.92201 13.8778 8.85339 13.8778 9.80877V12.0735H17.2043L16.6734 15.5621H13.8763V23.9985C19.6115 23.0926 24 18.0982 24 12.0735Z",
    fill: "#0B6EBE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.0f6ae0a90ae5e30a34926ee7a5b14283.svg";
export { ForwardRef as ReactComponent };